import { render } from "./editGradeTypePop.vue?vue&type=template&id=20b71a8d&scoped=true"
import script from "./editGradeTypePop.vue?vue&type=script&lang=js"
export * from "./editGradeTypePop.vue?vue&type=script&lang=js"

import "./editGradeTypePop.vue?vue&type=style&index=0&id=20b71a8d&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b71a8d"]])

export default __exports__